import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/eid-adha.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import MainCalculatorsList from '../MainCalculators';
const TITLE = "Countdown to Eid al-Adha 2026 - Remaining Time Until Eid al-Adha 2026";
const DESCRIPTION = "Countdown to the festival, Eid al-Adha 2026, Eid date, remaining time for the festival, Eid date 2026, date of Eid al-Adha 2026, Eid al-Adha date 2026, remaining time until Eid 2026, Eid al-Adha 2026, remaining time until Eid al-Adha, remaining days until the festival, Eid al-Adha 2026, Eid al-Adha 2026, remaining time until Eid al-Adha 2026, Eid al-Adha 2026, Eid al-Adha 2026, date of Eid al-Adha, remaining days until Arafah day, Eid al-Adha date, date of Arafah day 2026, date of Eid al-Adha, remaining days until Eid al-Adha, Eid al-Adha, date of Eid al-Adha, Eid al-Adha, Eid al-Adha 2026, Eid al-Adha 1444 Hijri, remaining time until Eid al-Adha 2026, remaining time for Eid al-Adha, remaining time for Eid al-Adha 2026, date of Eid al-Adha 2026, Eid al-Adha blessing, Eid al-Adha, date of Eid al-Adha 2026, remaining time for Eid al-Adha, remaining time until Eid al-Adha, remaining time for the festival, Eid al-Adha 2026";
const KEYWORDS = "Countdown to the festival, Eid al-Adha 2026, Eid date, remaining time for the festival, Eid date 2026, date of Eid al-Adha 2026, Eid al-Adha date 2026, remaining time until Eid 2026, Eid al-Adha 2026, remaining time until Eid al-Adha, remaining days until the festival, Eid al-Adha 2026, Eid al-Adha 2026, remaining time until Eid al-Adha 2026, Eid al-Adha 2026, Eid al-Adha 2026, date of Eid al-Adha, remaining days until Arafah day, Eid al-Adha date, date of Arafah day 2026, date of Eid al-Adha, remaining days until Eid al-Adha, Eid al-Adha, date of Eid al-Adha, Eid al-Adha, Eid al-Adha 2026, Eid al-Adha 1444 Hijri, remaining time until Eid al-Adha 2026, remaining time for Eid al-Adha, remaining time for Eid al-Adha 2026, date of Eid al-Adha 2026, Eid al-Adha blessing, Eid al-Adha, date of Eid al-Adha 2026, remaining time for Eid al-Adha, remaining time until Eid al-Adha, remaining time for the festival, Eid al-Adha 2026";
const OG_URL = "https://do-calculate.com/articles-en/eid-adha";
function EidAdha() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const initialDate = new Date("2026-06-07T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(initialDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);
    const ramadanDates = [
        { name: 'Eid al-Adha 2026', date: new Date("2026-05-27T00:00:00") },
        { name: 'Eid al-Adha 2027', date: new Date("2027-05-17T00:00:00") },
        { name: 'Eid al-Adha 2028', date: new Date("2028-05-05T00:00:00") },
        { name: 'Eid al-Adha 2029', date: new Date("2029-04-24T00:00:00") }
    ];
    return (
        <div >
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
           <div className="row">
    <FirstAds />
</div>
<h1 className='p-3 mb-2 bg-success text-white'>
    Remaining time until Eid al-Adha 2026
</h1>
<div>
    <BlinkingText text="Remaining time until Eid al-Adha: Eid al-Adha 2026 is expected to start on Saturday, 06/07/2026 Gregorian and 12/11/1446 Hijri according to the Hijri calendar." />
</div>
<div className="row">
    <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                            <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
            <thead>
                <tr>
                    <th >Days</th>
                    <th >Hours</th>
                    <th >Minutes</th>
                    <th >Seconds</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td id="days">{timeLeft.days}</td>
                    <td id="hours">{timeLeft.hours}</td>
                    <td id="minutes">{timeLeft.minutes}</td>
                    <td id="seconds">{timeLeft.seconds}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div className="row">
    <SecondAds />
</div>
<div className="row">
    <div className="col-12 col-md-8">
        <div>
            <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>Upcoming Eid al-Adha Dates</h2>
            <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                <thead>
                    <tr style={{ backgroundColor: '#f2f2f2' }}>
                        <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Eid al-Adha Date</th>
                        <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Date</th>
                        <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Remaining</th>
                    </tr>
                </thead>
                <tbody>
                    {ramadanDates.map((ramadan, index) => (
                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                            <td style={{ padding: '12px' }}>{ramadan.name}</td>
                            <td style={{ padding: '12px' }}>{ramadan.date.toLocaleDateString('en-GB')}</td>
                            <td style={{ padding: '12px' }}>{calculateTimeLeft(ramadan.date).days} day</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
    <div className="col-sm-4 col-md-4">
        <MainCalculatorsList CalculatorsTypeId={CalculatorsType.TimeArticles_En}></MainCalculatorsList>
    </div>
</div>
<div className="row">
    <div className="col-12 col-md-8">
        <h3 className='p-3 mb-2 bg-success text-white'>Remaining Time Until Eid al-Adha 2026</h3>
        <p>
            In this article, we present to you the detailed countdown for Eid al-Adha, so you can always be informed about how many days are left until the arrival of this honorable occasion. Many of us wonder how much time is left until Eid al-Adha, so in this article, we provide you with the countdown to Eid al-Adha to know how much time is left, how many days are left until Eid al-Adha. Watch the countdown for Eid al-Adha above.
        </p>
        <p>
            According to the <a href='/calculator/en/gregorian_to_hijri/'>date converter</a>, Eid al-Adha 2026 falls on Saturday, 06/07/2026 Gregorian and 11/12/1446 Hijri. You can view the countdown for Eid al-Adha 2026 in this article.
        </p>
        <p>Here you will find the countdown for Eid al-Adha, where you can know how many days are left until Eid al-Adha.
        </p>
        <hr />
        <RelatedLinks />
        <hr />
        <h3 className='p-3 mb-2 bg-success text-white'>
            Calculate Remaining Days Until Eid al-Adha
        </h3 >
                    <p>
    Through the countdown program for Eid al-Adha, you can find out how many days are left until Eid al-Adha in both the Gregorian and Hijri calendars. You can also know how many days remain until Eid al-Adha, how many days are left until Eid al-Adha in days, and when is the countdown for Eid al-Adha, remaining until Eid al-Adha, how many days are left until Eid al-Adha, how many days are left until Eid al-Adha, how many days are left until Eid al-Adha, how many days are left until Eid al-Adha, how many days are left until Eid al-Adha, how many days are left until Eid al-Adha, how many days are left until Eid al-Adha, how many days are left until Eid al-Adha, how many days are left until Eid al-Adha, how many days are left until Eid al-Adha, how many days are left until Eid al-Adha, how many days are left until Eid al-Adha, how many days are left until Eid al-Adha, and the date of Eid al-Adha for this year. Wishing you all the best and may Allah bless you with peace and blessings.
</p>
<h3 className='p-3 mb-2 bg-success text-white'>
    Eid al-Adha
</h3>
<p>
    Eid al-Adha is one of the two major festivals in Islam (the other being Eid al-Fitr). It falls on the 10th of Dhu al-Hijjah after the conclusion of the day of Arafah, the day when Muslim pilgrims stand in vigil to perform the most important rituals of Hajj, and ends on the 13th of Dhu al-Hijjah.
</p>
<div>
    <br />
    <img src={imageUrl} alt="Remaining time until Eid al-Adha" style={{ width: '100%', height: 'auto' }} />
    <br />
</div>
<h3 className='p-3 mb-2 bg-success text-white'>
    Aspects of Muslims Celebrating Eid al-Adha
</h3>
<p>
    On Eid al-Adha, Muslims around the world perform religious rites and specific rituals. We celebrate, visit our relatives and loved ones, and our wealthy ones provide for the poor on this great day. The days of Eid are from the tenth to the thirteenth of the same month of Dhu al-Hijjah.
</p>
                    <ul>
                    </ul>
                </div>
                <br />
            </div>
        </div>
    );
}
export default EidAdha;